module.exports = __webpack_public_path__ + "static/assets/d2f4c2118dd28a13fdef9ad0c56680f1.png";